import { useCallback, useEffect, useState } from 'react';
import { Alert } from 'react-native';
import { isLoggedIn } from '../api/auth';
import { getFavoritePersonState, toggleFavoritePerson } from '../api/library';

export function useFavoritePersonState(personId?: number, onRequireLogin?: () => void) {
  const [favorite, setFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    if (!personId || !isLoggedIn()) {
      setFavorite(false);
      return () => {
        mounted = false;
      };
    }

    getFavoritePersonState(personId)
      .then((state) => {
        if (mounted) setFavorite(state.is_favorite);
      })
      .catch(() => {
        if (mounted) setFavorite(false);
      });

    return () => {
      mounted = false;
    };
  }, [personId]);

  const toggle = useCallback(async () => {
    if (!personId) return;

    if (!isLoggedIn()) {
      onRequireLogin?.();
      return;
    }

    const nextFavorite = !favorite;
    setFavorite(nextFavorite);
    setLoading(true);

    try {
      const state = await toggleFavoritePerson(personId, nextFavorite);
      setFavorite(state.is_favorite);
    } catch {
      setFavorite(favorite);
      Alert.alert('Không thể cập nhật yêu thích', 'Vui lòng thử lại sau.');
    } finally {
      setLoading(false);
    }
  }, [favorite, onRequireLogin, personId]);

  return { favorite, loading, toggle };
}
